import { render } from "./PrecipitationLegend.vue?vue&type=template&id=304ff950&scoped=true"
import script from "./PrecipitationLegend.vue?vue&type=script&lang=js"
export * from "./PrecipitationLegend.vue?vue&type=script&lang=js"

import "./PrecipitationLegend.vue?vue&type=style&index=0&id=304ff950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304ff950"]])

export default __exports__